import { validateAgainstSchema, type PromptExecutionSpec } from '@whittlelabs/loom';

/**
 * Fail-closed schema check for a prompt-execution output (ADR 0005). Structural
 * validation is intrinsic to the strategy: an executor that produced output not
 * conforming to `spec.outputSchema` failed its job, so we throw and let the
 * claim loop mark the attendance failed (Jobs retries up to maxAttempts). The
 * provider's structured-output mode is the first line of defence; this is the
 * universal net behind it.
 */
export function assertOutputValid(spec: PromptExecutionSpec, parsed: unknown): void {
  const { valid, errors } = validateAgainstSchema(parsed ?? null, spec.outputSchema);
  if (!valid) {
    throw new Error(`prompt-execution output failed schema validation: ${errors.join('; ')}`);
  }
}
